import React from "react";
import { Link } from "react-router-dom";

const VARIANT_CLASSES = {
  primary: "bg-[var(--button-primary-bg,theme(colors.lime.600))] text-white hover:bg-[var(--button-primary-hover,theme(colors.lime.700))]",
  secondary: "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50",
  danger: "bg-red-600 text-white hover:bg-red-700",
  ghost: "bg-transparent text-gray-500 hover:bg-gray-100",
  warning: "bg-yellow-600 text-white hover:bg-yellow-700",
  info: "bg-blue-600 text-white hover:bg-blue-700",
  success: "bg-green-600 text-white hover:bg-green-700",
  "danger-outline": "bg-transparent text-red-600 border border-red-200 hover:bg-red-50 hover:text-red-700",
  none: "",
};

export const Button = ({
  type = "button",
  variant = "primary",
  className = "",
  disabled = false,
  loading = false,
  asChild: _asChild,
  to,
  onClick,
  children,
  ...props
}) => {
  const variantClass = VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.primary;
  const baseClass = "rounded-xl h-10 px-6 text-sm font-semibold inline-flex items-center justify-center transition-all duration-200 shadow-none disabled:opacity-60 disabled:cursor-not-allowed";
  const combinedClass = `${baseClass} ${variantClass} ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={combinedClass} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={combinedClass}
      {...props}
    >
      {loading ? "Loading..." : children}
    </button>
  );
};
